// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as LoaderComponent} from './Loader.svg';

import Icon, { TIconProps } from '../Icon';

export const IconLoader = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <LoaderComponent/>
  </Icon>
));
